import { ActionStore } from "@/stores/ActionStore";
import { MetaDataStore } from "@/stores/MetaDataStore";
import { ThumbStore } from "@/stores/ThumbStore";
import { UserStore } from "@/stores/UserStore";

export class RootStore {
  readonly actionStore: ActionStore;
  readonly metaDataStore: MetaDataStore;
  readonly thumbStore: ThumbStore;
  readonly userStore: UserStore;

  constructor() {
    this.actionStore = new ActionStore();
    this.metaDataStore = new MetaDataStore();
    this.thumbStore = new ThumbStore();
    this.userStore = new UserStore();
  }
}
